import { render } from "./ModalEditarExame.vue?vue&type=template&id=1e3c0862&scoped=true"
import script from "./ModalEditarExame.vue?vue&type=script&lang=js"
export * from "./ModalEditarExame.vue?vue&type=script&lang=js"

import "./ModalEditarExame.vue?vue&type=style&index=0&id=1e3c0862&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e3c0862"]])

export default __exports__